module.exports = __webpack_public_path__ + "static/media/test19_3.d10900b4.png";